export default __webpack_public_path__ + "static/media/navbarAvatar.aeb7e402.png";